var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Reproductor',{attrs:{"msg":"Los consonantes","audio2":"../mp3/PrimariaB/02PB.mp3","cover":"../img/2.jpg","name":"Primaria B - Lección #2"}}),_c('Buttons')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }